/**
 * 実績詳細ページ用スクリプト（index.html から変換）
 * - PC/SP デバイスフレーム切替
 * - ケーススタディ Index アコーディオン（SP）
 * - スクロールアニメーション（anim-fade-up）
 */
(function () {
  'use strict';

  function initWorksDetail(prefix) {
    prefix = prefix || 'worksDetail';
    var pcBtn = document.getElementById('js-' + prefix + '-pcBtn');
    var spBtn = document.getElementById('js-' + prefix + '-spBtn');
    var pcFrame = document.getElementById('js-' + prefix + '-pcFrame');
    var spFrame = document.getElementById('js-' + prefix + '-spFrame');

    if (pcBtn && spBtn && pcFrame && spFrame) {
      var isToggling = false;
      function switchDevice(hideEl, showEl, activeBtn, inactiveBtn) {
        if (isToggling) return;
        if (activeBtn.classList.contains('is-active')) return;
        isToggling = true;
        inactiveBtn.classList.remove('is-active');
        inactiveBtn.setAttribute('aria-pressed', 'false');
        activeBtn.classList.add('is-active');
        activeBtn.setAttribute('aria-pressed', 'true');
        hideEl.style.transition = 'opacity 0.22s ease, transform 0.22s ease';
        hideEl.style.opacity = '0';
        hideEl.style.transform = 'scale(0.97)';
        setTimeout(function () {
          hideEl.style.display = 'none';
          hideEl.setAttribute('aria-hidden', 'true');
          hideEl.style.transition = '';
          hideEl.style.opacity = '';
          hideEl.style.transform = '';
          showEl.style.opacity = '0';
          showEl.style.transform = 'scale(0.97)';
          showEl.style.transition = 'none';
          showEl.style.display = 'block';
          showEl.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              showEl.style.transition = 'opacity 0.32s cubic-bezier(0.16,1,0.3,1), transform 0.32s cubic-bezier(0.16,1,0.3,1)';
              showEl.style.opacity = '1';
              showEl.style.transform = 'scale(1)';
              setTimeout(function () {
                showEl.style.transition = '';
                isToggling = false;
              }, 340);
            });
          });
        }, 230);
      }
      pcBtn.addEventListener('click', function () {
        switchDevice(spFrame, pcFrame, pcBtn, spBtn);
      });
      spBtn.addEventListener('click', function () {
        switchDevice(pcFrame, spFrame, spBtn, pcBtn);
      });
    }

    var indexTrigger = document.getElementById('js-' + prefix + '-indexTrigger');
    var indexNav = document.getElementById('js-' + prefix + '-indexNav');
    if (indexTrigger && indexNav) {
      var indexIcon = indexTrigger.querySelector('.case-study__index-trigger-icon');
      indexTrigger.addEventListener('click', function () {
        var isOpen = indexNav.classList.contains('is-open');
        if (isOpen) {
          indexNav.classList.remove('is-open');
          indexTrigger.setAttribute('aria-expanded', 'false');
          if (indexIcon) indexIcon.textContent = '+';
        } else {
          indexNav.classList.add('is-open');
          indexTrigger.setAttribute('aria-expanded', 'true');
          if (indexIcon) indexIcon.textContent = '−';
        }
      });
    }

    if (window.Shopify && Shopify.designMode) {
      document.querySelectorAll('.anim-fade-up').forEach(function (el) {
        el.classList.add('is-visible');
      });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12 }
      );
      document.querySelectorAll('.anim-fade-up').forEach(function (el) {
        observer.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWorksDetail('worksDetail');
      initWorksDetail('customWorksDetail');
    });
  } else {
    initWorksDetail('worksDetail');
    initWorksDetail('customWorksDetail');
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      initWorksDetail('worksDetail');
      initWorksDetail('customWorksDetail');
    });
  }
})();
